/* eslint-disable max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  fetchStoreManagementDetail,
  fetchStoreManagementList,
  searchStore,
  getVideoCount,
  transferVideos,
  fetchFoodCategoryGroups,
  getSpecialTypeList,
  getSingleSpecialType,
  fetchBriefInfo,
  getStoreImages
} from './asyncAction'

const initialState: TStoreManagement.State = {
  storeManagementListData: {
    data: [],
    pageIndex: 1,
    pageSize: 50,
    totalRecords: 0,
    totalPage: 0,
    hasNextPage: false,
    hasPreviousPage: false
  },
  isFetchingStoreListData: true,
  searchParams: {
    KeyWord: '',
    OrderDirection: '',
    PageIndex: 1,
    PageSize: 50,
    Province: '',
    ReviewState: '',
    Status: '',
    StoreCD: '',
    StoreName: '',
    UserId: '',
    VideoCount: 0,
    OptRequest: 0,
    StoreTag: '',
    OrderField: '',
    SpecialType: null
  },
  specialTypeList: {
    data: []
  },
  specialTypeUpsert: {
    data: {
      id: '',
      name: ''
    }
  },
  selectedSpecialTypeName: 'ご選択ください',
  selectedSpecialTypeId: null,
  selectedStoreIdForRowUpdate: null,
  isSearching: false,
  isUploading: false,
  isDownloading: false,
  isFetchingStoreDetail: false,
  storeManagementDetail: {
    data: {
      id: '',
      foodCategoryGroups: [],
      masterStoreCD: '',
      masterStoreMangementName: '',
      masterStoreName: '',
      englishName: '',
      registerDate: '',
      status: 1,
      storeMangementName: '',
      storeName: '',
      videoCount: 1,
      province: '',
      provinceGroup: '',
      area: '',
      subArea: '',
      reviewState: '',
      storeCD: '',
      isNeedApprove: true,
      address: '',
      branchName: '',
      buildingName: '',
      furigana: '',
      phonenumber: '',
      postalCode: '',
      paymentType: 'STORE',
      paymentMethods: [],
      street: '',
      registeredDate: '',
      bankAccountHolder: '',
      bankAccountNumber: '',
      bankAccountType: 1,
      bankBranch: '',
      bankName: '',
      coupon: '',
      businessType: 1,
      isApproved: false,
      isRegister: true,
      paymentMethod: 1,
      serviceOptions: [],
      practicingCertificatePath: '',
      companyName: '',
      registerEmail: '',
      imageAttachmentId: '',
      registerName: '',
      registerNameKana: '',
      registerOccupation: '',
      registerPhonenumber: '',
      imageAttachmentFileName: '',
      branchType: 'STORE',
      billingBy: '',
      billingMethod: '',
      type: '',
      adminNotification: '',
      kidRecommendation: '',
      newShopIntroductionThumbUrl: '',
      isNewIntroduction: false,
      introduceThumbnail: null,
      storeTag: 0,
      newOrderProducts: [],
      storeImages: [],
      checked: false,
      specialTypeId: '',
      specialTypeName: ''
    },
    introductionThumbnailUploadedFile: null,
    showDeleteConfirmModal: false,
    deleteNewMailOrderId: '',
    deleteNewMailOrderIndex: null
  },
  destinationStore: {},
  showTransferVideoModal: false,
  transferStatus: 'idle',
  goLiverVideoCount: 0,
  foodCategoryGroups: [],
  showErrorDataDownloadConfirmModal: false,
  showSpecialTypeUpdateModal: false,
  showManageSpecialTypeModal: false,
  storeBriefInfo: {
    id: '',
    storeName: '',
    storeCD: ''
  }
}

const slice = createSlice({
  name: 'storeManagement',
  initialState,
  reducers: {
    setIsSearching (state, action: PayloadAction<boolean>) {
      state.isSearching = action.payload
    },
    setIsUploading (state, action) {
      state.isUploading = action.payload
    },
    setIsDownloading (state, action) {
      state.isDownloading = action.payload
    },
    setFieldInStoreDetails (
      state,
      action: PayloadAction<{ value: any, field: keyof TStoreManagement.State['storeManagementDetail']['data'] }>
    ) {
      const { value, field } = action.payload
      // @ts-ignore
      state.storeManagementDetail.data[field] = value
    },
    setIsApproved (state, action: PayloadAction<boolean>) {
      state.storeManagementDetail.data.isApproved = action.payload
    },
    setSearchParams (state, action) {
      state.searchParams = action.payload
    },
    clearDestinationStore (state) {
      state.destinationStore = {}
    },
    setShowTransferVideoModal (state, action) {
      state.showTransferVideoModal = action.payload
    },
    setTransferStatus (state, action) {
      state.transferStatus = action.payload
    },
    changeImage: (state, action: PayloadAction<File>) => {
      const imageFile = action.payload
      if (imageFile) {
        state.storeManagementDetail.introductionThumbnailUploadedFile = imageFile
        state.storeManagementDetail.data.newShopIntroductionThumbUrl = URL.createObjectURL(imageFile)
      }
    },
    removeNewShopIntroThumb (state) {
      state.storeManagementDetail.data.newShopIntroductionThumbUrl = ''
      state.storeManagementDetail.introductionThumbnailUploadedFile = undefined
    },
    setIsNewIntroduction: (state, action) => {
      state.storeManagementDetail.data.isNewIntroduction = action.payload
    },
    setShowErrorDataDownloadConfirmModal: (state, action) => {
      state.showErrorDataDownloadConfirmModal = action.payload
    },
    setStoreTag: (state, action) => {
      const store = state.storeManagementListData.data.filter(x => x.id === action.payload.id)[0]
      if (store) {
        store.storeTag = action.payload.storeTag
      }
    },
    addDataToListNewMailOrder: state => {
      // check order is exist image upload
      const indexMax = state.storeManagementDetail.data.newOrderProducts?.length ?? 0
      if (indexMax === 0
        || state.storeManagementDetail.data.newOrderProducts[indexMax - 1]?.thumbnailUrl !== ''
        || state.storeManagementDetail.data.newOrderProducts[indexMax - 1]?.thumbnail
      ) {
        if (state.storeManagementDetail.data.newOrderProducts) {
          state.storeManagementDetail.data.newOrderProducts.push({
            id: null,
            checked: false,
            thumbnailUrl: '',
            thumbnailFile: null,
            isDelete: false
          })
        } else {
          state.storeManagementDetail.data.newOrderProducts = [{
            id: null,
            checked: false,
            thumbnailUrl: '',
            thumbnailFile: null,
            isDelete: false
          }]
        }
      }
    },
    setIsNewMailOrder: (state, action) => {
      state.storeManagementDetail.data.newOrderProducts[action.payload.index].checked = action.payload.value
    },
    changeImageNewMailOrder: (state, action) => {
      const { imageFile } = action.payload
      if (imageFile) {
        state.storeManagementDetail.data.newOrderProducts[action.payload.index].thumbnailFile = imageFile
        state.storeManagementDetail.data.newOrderProducts[action.payload.index].thumbnailUrl = URL.createObjectURL(imageFile)
      }
    },
    removeImageNewMailOrder: (state, action) => {
      const dataAction = state.storeManagementDetail.data.newOrderProducts[action.payload.index]
      dataAction.thumbnailFile = null
      dataAction.thumbnailUrl = ''
      if (dataAction.id) dataAction.isDelete = true
    },
    setShowDeleteConfirmModal: (state, action) => {
      state.storeManagementDetail.showDeleteConfirmModal = action.payload
    },
    setIsNewMailOrderID: (state, action) => {
      state.storeManagementDetail.deleteNewMailOrderId = action.payload
    },
    setCheckOne: (state, action) => {
      const { data } = state.storeManagementListData
      const store = data.filter(x => x.id === action.payload.id)[0]
      if (store) {
        store.checked = action.payload.checked
      }
    },
    setCheckAll: (state, action) => {
      const { data } = state.storeManagementListData
      data.forEach(s => {
        s.checked = action.payload
      })
    },
    setShowSpecialTypeUpdateModal: (state, action) => {
      state.showSpecialTypeUpdateModal = action.payload
    },
    setShowManageSpecialTypeModal: (state, action) => {
      state.showManageSpecialTypeModal = action.payload
    },
    setUpdateSpecialTypeName: (state, action) => {
      state.specialTypeUpsert.data.name = action.payload
    },
    resetUpdateSpecialType: state => {
      state.specialTypeUpsert = initialState.specialTypeUpsert
    },
    setSelectedSpecialTypeName: (state, action) => {
      state.selectedSpecialTypeName = action.payload
    },
    setSelectedSpecialTypeId: (state, action) => {
      state.selectedSpecialTypeId = action.payload
    },
    setUpdateSpecialTypeId: (state, action) => {
      state.specialTypeUpsert.data.id = action.payload
    },
    setSelectedStoreIdForRowUpdate: (state, action) => {
      state.selectedStoreIdForRowUpdate = action.payload
    },
    setNewMailOrderIndexDelete: (state, action) => {
      state.storeManagementDetail.deleteNewMailOrderIndex = action.payload
    },
    removeMailOrderByIndex: state => {
      if (state.storeManagementDetail.deleteNewMailOrderIndex !== null) {
        state.storeManagementDetail.data.newOrderProducts.splice(state.storeManagementDetail.deleteNewMailOrderIndex, 1)
        setNewMailOrderIndexDelete(null)
      }
    },
    setStoreImageChecked: (state, action) => {
      const image = state.storeManagementDetail.data.storeImages[action.payload.index]
      if (image) {
        image.checked = action.payload.checked
      }
    },
    addStoreImage: state => {
      state.storeManagementDetail.data.storeImages.push({
        id: null,
        checked: false,
        imageUrl: '',
        imageFile: null,
        index: state.storeManagementDetail.data.storeImages.length
      })
    },
    removeStoreImage: (state, action) => {
      const deletedItem = state.storeManagementDetail.data.storeImages.filter(x => x.id === action.payload)[0]
      if (deletedItem) {
        const index = state.storeManagementDetail.data.storeImages.indexOf(deletedItem)
        if (index !== -1) {
          state.storeManagementDetail.data.storeImages.splice(index, 1)
        }
      }
    },
    removeStoreImageByIndex: (state, action) => {
      const deletedItem = state.storeManagementDetail.data.storeImages[action.payload]
      if (deletedItem) {
        state.storeManagementDetail.data.storeImages.splice(action.payload, 1)
      }
    },
    changeStoreImage: (state, action) => {
      const { imageFile } = action.payload
      if (imageFile) {
        state.storeManagementDetail.data.storeImages[action.payload.index].imageFile = imageFile
        state.storeManagementDetail.data.storeImages[action.payload.index].imageUrl = URL.createObjectURL(imageFile)
      }
    },
    removeStoreImageFile: (state, action) => {
      const dataAction = state.storeManagementDetail.data.storeImages[action.payload]
      dataAction.imageFile = null
      dataAction.imageUrl = ''
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchStoreManagementList.fulfilled, (
        state,
        action: PayloadAction<TStoreManagement.State['storeManagementListData']>
      ) => {
        if (!action.payload) return
        state.storeManagementListData = action.payload
        state.storeManagementListData.data.forEach((s: any) => {
          if (s.checked) s.checked = false
        })
        state.isFetchingStoreListData = false
      })
      .addCase(fetchStoreManagementList.pending, state => {
        state.isFetchingStoreListData = true
      })
    builder
      .addCase(fetchStoreManagementDetail.fulfilled, (
        state,
        action: PayloadAction<TStoreManagement.State['storeManagementDetail']>
      ) => {
        if (!action.payload?.data) return
        state.storeManagementDetail.data = action.payload.data
        state.isFetchingStoreDetail = false
      })
      .addCase(fetchStoreManagementDetail.pending, state => {
        state.isFetchingStoreDetail = true
      })
    builder.addCase(searchStore.fulfilled, (state, action) => {
      state.destinationStore = action.payload
    })
    builder.addCase(getVideoCount.fulfilled, (state, action) => {
      state.goLiverVideoCount = action.payload
    })
    builder
      .addCase(transferVideos.pending, state => {
        state.transferStatus = 'transfering'
      })
      .addCase(transferVideos.rejected, state => {
        state.transferStatus = 'failure'
      })
      .addCase(transferVideos.fulfilled, state => {
        state.transferStatus = 'success'
      })
    builder.addCase(fetchFoodCategoryGroups.fulfilled, (state, action) => {
      state.foodCategoryGroups = action.payload
    })
    builder.addCase(getSpecialTypeList.fulfilled, (state, action) => {
      state.specialTypeList = action.payload
    })
    builder.addCase(getSingleSpecialType.fulfilled, (state, action) => {
      state.specialTypeUpsert = action.payload
    })
    builder.addCase(fetchBriefInfo.fulfilled, (state, action) => {
      state.storeBriefInfo = action.payload
    })
    builder.addCase(getStoreImages.fulfilled, (state, action) => {
      state.storeManagementDetail.data.storeImages = action.payload
    })
  }
})

export const {
  setIsSearching,
  setFieldInStoreDetails,
  setIsApproved,
  setIsDownloading,
  setIsUploading,
  setSearchParams,
  clearDestinationStore,
  setShowTransferVideoModal,
  setTransferStatus,
  changeImage,
  setIsNewIntroduction,
  setShowErrorDataDownloadConfirmModal,
  removeNewShopIntroThumb,
  setStoreTag,
  setIsNewMailOrder,
  addDataToListNewMailOrder,
  changeImageNewMailOrder,
  removeImageNewMailOrder,
  setShowDeleteConfirmModal,
  setIsNewMailOrderID,
  setCheckAll,
  setCheckOne,
  setShowSpecialTypeUpdateModal,
  setShowManageSpecialTypeModal,
  setUpdateSpecialTypeName,
  resetUpdateSpecialType,
  setSelectedSpecialTypeName,
  setSelectedSpecialTypeId,
  setUpdateSpecialTypeId,
  setNewMailOrderIndexDelete,
  removeMailOrderByIndex,
  setSelectedStoreIdForRowUpdate,
  setStoreImageChecked,
  addStoreImage,
  changeStoreImage,
  removeStoreImage,
  removeStoreImageFile,
  removeStoreImageByIndex
} = slice.actions

export * from './asyncAction'

export const storeManagementReducer = slice.reducer
